import api from "@/services/api";

export default {
  namespaced: true,

  state: () => ({
    comprobantes: [],
    actual: null,
    loading: false,
    error: null,
  }),

  getters: {
    comprobantes: (s) => s.comprobantes,
    actual: (s) => s.actual,
    loading: (s) => s.loading,
    error: (s) => s.error,
  },

  mutations: {
    setComprobantes(state, data) {
      state.comprobantes = data;
    },
    setActual(state, data) {
      state.actual = data;
    },
    setLoading(state, v) {
      state.loading = v;
    },
    setError(state, v) {
      state.error = v;
    },
    clearState(state) {
      state.comprobantes = [];
      state.actual = null;
      state.error = null;
    },
  },

  actions: {
    async getComprobantes({ commit }, params = {}) {
      commit("setLoading", true);
      commit("setError", null);
      try {
        const { data } = await api.get("/comprobantes", { params });
        commit("setComprobantes", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async getComprobante({ commit }, id) {
      commit("setLoading", true);
      try {
        const { data } = await api.get(`/comprobantes/${id}`);
        commit("setActual", data);
        return data;
      } catch (e) {
        commit("setError", e.response?.data?.detail || e.message);
        throw e;
      } finally {
        commit("setLoading", false);
      }
    },

    async crearComprobante(_, payload) {
      const { data } = await api.post("/comprobantes", payload);
      return data;
    },

    async actualizarComprobante(_, { id, ...payload }) {
      const { data } = await api.patch(`/comprobantes/${id}`, payload);
      return data;
    },

    async eliminarComprobante(_, id) {
      await api.delete(`/comprobantes/${id}`);
    },

    async agregarItem(_, { comprobanteId, ...item }) {
      const { data } = await api.post(
        `/comprobantes/${comprobanteId}/items`,
        item
      );
      return data;
    },

    async eliminarItem(_, { comprobanteId, itemId }) {
      await api.delete(`/comprobantes/${comprobanteId}/items/${itemId}`);
    },

    async uploadFoto(_, { comprobanteId, file }) {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await api.post(
        `/comprobantes/${comprobanteId}/upload-foto`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return data;
    },
  },
};
